import { removeLastSlash, removeLinkParams } from './link';
export const baseTwitchPath = 'twitch.tv/';
export const baseEmbeddedPath = 'https://player.twitch.tv/?';
const createEmbeddedLink = (link) => {
    const paths = removeLastSlash(removeLinkParams(link))
        ?.split(baseTwitchPath)[1]
        .split('/');
    const finalPath = paths?.length === 1
        ? `channel=${paths[0]}`
        : paths?.length === 3
            ? `video=${paths[2]}`
            : undefined;
    return finalPath
        ? `${baseEmbeddedPath}${finalPath}&parent=${window.location.hostname}&autoplay=false`
        : undefined;
};
export const twitch = {
    category: 'VIDEO',
    isSatisfied: (link) => link.includes(baseTwitchPath),
    getPlayerExecutionProps: (link) => ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media',
    }),
};
